


function isUndefined(value) {
  return value === undefined;
}

module.exports = isUndefined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash.isundefined/index.js
// module id = 1163
// module chunks = 0